import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import Tooltip from 'components/tooltip';

const NotFinishedProfileIcon = ({ lead }) => {
  const isFullyFinished = !!lead.profileUserType;

  return lead.profileId && !isFullyFinished &&
    <Tooltip content="This lead has not completed their profile information" placement="right">
      <FontAwesomeIcon
        className="icon ml-2 text-jelly"
        icon={faExclamationCircle}
      />
    </Tooltip>;
};

NotFinishedProfileIcon.propTypes = {
  lead: PropTypes.object.isRequired
};

export default NotFinishedProfileIcon;
